import React from "react"
import { Button, Modal, Table, Spinner, Col, Form, Row, Image } from "react-bootstrap"
import { toast } from "react-toastify"
import { connect } from "react-redux"
import { concat, of, Subject, Subscription, forkJoin } from "rxjs"
import { catchError, map, switchMap } from "rxjs/operators"
import ActionButton from "../ActionButton"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import { RouteComponentProps } from "react-router"
import { Home } from "../../config/Routes"
import Checkbox from "../Checkbox"
import { APIError } from "../../api/ObservableFromFetch"
import { AppState, WorkforceClinicPortal, AssignedClinic } from "../../AppState"
import { isPortalAdmin, isCompanyAdmin } from "../../authentication/isAdminRole"
import { GetSelectedPortal, GetSelectedAssignedClinic, getUserNameForSelectedCompany } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import KeyValue from "../../api/Administration/Model/KeyValue"
import CompanyUserCode, { CreateEmptyCompanyUserCode, CopyCompanyUserCode, CopyCompanyUserCodes } from "../../api/Administration/Model/ComapnyUserCode"
import GetImplementationAliasFields from "../../api/Administration/ImplementationAliasFields"
import GetCompanyUserCodes from "../../api/Administration/CompanyUserCodes"
import DeleteQueryImg from '../../assets/images/delete_query.png'
import CompanyUserCodeModal from "./CompanyUserCodeModal"
import ConfirmationModal from "../ConfirmationModal"
import { DeleteCompanyUserCode } from "../../api/Administration/CompanyUserCodes"
import IdName from "../../api/Administration/Model/IdName"
import CompanyInput from "../FormattedInputs/CompanyInput"
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"

interface UserCodesModalAuthProps {
  isPortalAdmin?: boolean
  isCompanyAdmin?: boolean
  UserName?: string
  Company?: AssignedClinic
  Portal?: WorkforceClinicPortal
}

interface UserCodesModalProps { }

interface UserCodesModalState {
  loading: boolean
  implementationFields: KeyValue[]
  implementationFieldsLoading: boolean
  selectedCompany?: AutoFilterCompany
  selectedCompanyID: number
  selectedCode: string
  companyUserCodes: CompanyUserCode[]
  companyUserCodesLoading: boolean
  showCompanyUserCodeEditor: boolean
  selectedIndex: number
  selectedUserCode: CompanyUserCode
  showOnDeleteConfirmation: boolean
  deletingUserCode: boolean
}


export class UserCodesModal extends React.PureComponent<UserCodesModalProps & UserCodesModalAuthProps, UserCodesModalState> {
  emptyState: UserCodesModalState = {
    loading: false,
    implementationFields: [],
    implementationFieldsLoading: false,
    selectedCompany: undefined,
    selectedCompanyID: 0,
    selectedCode: "",
    companyUserCodes: [],
    companyUserCodesLoading: false,
    showCompanyUserCodeEditor: false,
    selectedIndex: -1,
    selectedUserCode: CreateEmptyCompanyUserCode(),
    showOnDeleteConfirmation: false,
    deletingUserCode: false

  }
  state: UserCodesModalState = { ...this.emptyState }

  deleteSubscription?: Subscription
  loadImplementationFieldsSubscription?: Subscription
  loadCompanyCodesSubscription?: Subscription

  componentDidMount() {
    this.loadInitialData()
  }

  componentWillUnmount() {
    this.deleteSubscription && this.deleteSubscription.unsubscribe()
    this.loadImplementationFieldsSubscription && this.loadImplementationFieldsSubscription.unsubscribe()
    this.loadCompanyCodesSubscription && this.loadCompanyCodesSubscription.unsubscribe()
  }

  loadInitialData() {
    this.loadImplementationFieldsSubscription && this.loadImplementationFieldsSubscription.unsubscribe()
    this.loadCompanyCodesSubscription && this.loadCompanyCodesSubscription.unsubscribe()
    let selectedCompanyID = 0
    const selectedUserCode = CreateEmptyCompanyUserCode()
    this.setState({
      implementationFields: [],
      implementationFieldsLoading: true,
      selectedCode: "",
      companyUserCodes: [],
      companyUserCodesLoading: true,
      selectedIndex: -1,
      selectedUserCode: selectedUserCode
    })

    this.loadImplementationFieldsSubscription = GetImplementationAliasFields().subscribe(
      (data: KeyValue[]) => {
        const selectedCode = (data.length > 0) ? data[0].Key : ""
        this.setState({ implementationFields: data, implementationFieldsLoading: false, selectedCode: selectedCode })
        this.loadCompanyCodesSubscription = GetCompanyUserCodes(selectedCompanyID, selectedCode).subscribe(
          (data: CompanyUserCode[]) => {
            this.setState({ companyUserCodes: data, companyUserCodesLoading: false })
          },
          (error) => this.handleAPIError(error, { companyUserCodes: [], companyUserCodesLoading: false })
        )
      },
      (error) => this.handleAPIError(error, { implementationFields: [], implementationFieldsLoading: false, companyUserCodesLoading: false })
    )
  }

  handleCancel = () => (this.props as RouteComponentProps).history?.push(Home)

  handleAdd = () => {
    const itemIndex = -1
    const selectedUserCode = this.getItemForEdit(itemIndex);
    this.setState({ selectedIndex: itemIndex, selectedUserCode: selectedUserCode, showCompanyUserCodeEditor: true })

  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  handleImplementationFieldChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCode = event.target.value
    const selectedCompany = this.state.selectedCompany
    const selectedCompanyID = selectedCompany?.AccountID || 0
    const selectedUserCode = CreateEmptyCompanyUserCode()
    this.setState({ selectedCode: selectedCode, companyUserCodesLoading: true, selectedIndex: -1, selectedUserCode: selectedUserCode })
    this.loadCompanyCodesSubscription && this.loadCompanyCodesSubscription.unsubscribe()
    this.loadCompanyCodesSubscription = GetCompanyUserCodes(selectedCompanyID, selectedCode).subscribe(
      (data: CompanyUserCode[]) => {
        this.setState({ selectedCode: selectedCode, companyUserCodes: data, companyUserCodesLoading: false })
      },
      (error) => this.handleAPIError(error, { selectedCode: selectedCode, companyUserCodes: [], companyUserCodesLoading: false })
    )
  }

  handleCompanyChange = (companies: AutoFilterCompany[]) => {
    const selectedCode = this.state.selectedCode
    const selectedCompany = companies[0]
    const selectedCompanyID = selectedCompany?.AccountID || 0
    const selectedUserCode = CreateEmptyCompanyUserCode()
    this.setState({ companyUserCodesLoading: true, selectedIndex: -1, selectedUserCode: selectedUserCode })
    this.loadCompanyCodesSubscription && this.loadCompanyCodesSubscription.unsubscribe()

    this.loadCompanyCodesSubscription = GetCompanyUserCodes(selectedCompanyID, selectedCode).subscribe(
      (data: CompanyUserCode[]) => {
        this.setState({ selectedCompany: selectedCompany, selectedCompanyID: selectedCompanyID, companyUserCodes: data, companyUserCodesLoading: false })
      },
      (error) => this.handleAPIError(error, { selectedCompany: selectedCompany, selectedCompanyID: selectedCompanyID, companyUserCodes: [], companyUserCodesLoading: false })
    )
  }

  getItemForEdit = (itemIndex: number) => {
    if (itemIndex >= 0) {
      return this.state.companyUserCodes[itemIndex]
    }
    const result = CreateEmptyCompanyUserCode()
    result.AccountID = this.state.selectedCompanyID
    result.UserFieldType = this.state.selectedCode
    return result

  }

  userCodeClick = (itemIndex: number) => {
    const selectedUserCode = this.getItemForEdit(itemIndex);
    this.setState({ selectedIndex: itemIndex, selectedUserCode: selectedUserCode, showCompanyUserCodeEditor: true })
  }
  userCodeDeleteClick = (itemIndex: number) => {
    const selectedUserCode = this.getItemForEdit(itemIndex);
    this.setState({ selectedIndex: itemIndex, selectedUserCode: selectedUserCode, showOnDeleteConfirmation: true })
  }
  
  DataRow = (data: CompanyUserCode, index: number) => {
    return <tr key={data.UserDefinedCodeID}>
      <td>
        <Button variant="underline-link" className="px-0 mx-0 " onClick={() => this.userCodeClick(index)}>
          {data.Code}
        </Button>
      </td>
      <td>

        <Button variant="underline-link" className="px-0 mx-0 " onClick={() => this.userCodeClick(index)}>
          {data.Description}
        </Button>

      </td>
      <td>
        <Image src={DeleteQueryImg} title="Delete Query" onClick={() => this.userCodeDeleteClick(index)} />
      </td>
    </tr>
  }

  handleCompanyUserCodeSave = (data: CompanyUserCode) => {

    const selectedUserCode = CreateEmptyCompanyUserCode()
    const userDefinedCodeID = data.UserDefinedCodeID
    let companyUserCodes = CopyCompanyUserCodes(this.state.companyUserCodes)
    const itemIndex = this.state.companyUserCodes.findIndex(item => item.UserDefinedCodeID === userDefinedCodeID)
    if (itemIndex < 0) {
      companyUserCodes.push(data)
    }
    else{
      companyUserCodes[itemIndex].Description = data.Description
    }
    this.setState({ selectedIndex: -1, showCompanyUserCodeEditor: false, selectedUserCode: selectedUserCode, companyUserCodes: companyUserCodes })
  }
  handleCompanyUserCodeClose = () => {
    const selectedUserCode = CreateEmptyCompanyUserCode()
    this.setState({ selectedIndex: -1, showCompanyUserCodeEditor: false, selectedUserCode: selectedUserCode })
  }
  handleDeleteCompanyUserCode = () => {
    this.setState({ deletingUserCode: true })
    const emptyUserCode = CreateEmptyCompanyUserCode()
    const selectedUserCode = this.state.selectedUserCode
    this.deleteSubscription && this.deleteSubscription.unsubscribe()
    this.deleteSubscription = DeleteCompanyUserCode(selectedUserCode).subscribe(
      (data: number) => {
        let items = CopyCompanyUserCodes(this.state.companyUserCodes)
        const itemIndex = items.findIndex(item => item.UserDefinedCodeID === data);
        if (itemIndex >= 0) {
          items.splice(itemIndex, 1)
        }
        this.setState({ showOnDeleteConfirmation: false, deletingUserCode: false, selectedIndex: -1, selectedUserCode: emptyUserCode, companyUserCodes: items })
        toast.success("Record deleted successfully")
      },
      error => this.handleAPIError(error, { showOnDeleteConfirmation: false, deletingUserCode: false, selectedIndex: -1, selectedUserCode: emptyUserCode })
    )


  }
  handleCloseDeleteConfirmation = () => {
    const selectedUserCode = CreateEmptyCompanyUserCode()
    this.setState({ selectedIndex: -1, selectedUserCode: selectedUserCode, showOnDeleteConfirmation: false, deletingUserCode: false })
  }

  render() {
    const { implementationFields, implementationFieldsLoading, companyUserCodes, companyUserCodesLoading, showCompanyUserCodeEditor, selectedUserCode } = this.state
    const loading = implementationFieldsLoading || companyUserCodesLoading

    return (
      <>
        {showCompanyUserCodeEditor && <CompanyUserCodeModal
          selectedUserCode={selectedUserCode}
          show={showCompanyUserCodeEditor}
          onSave={(companyUserCode) => this.handleCompanyUserCodeSave(companyUserCode)}
          onClose={this.handleCompanyUserCodeClose} />
        }
        <ConfirmationModal show={this.state.showOnDeleteConfirmation}
          title=""
          textTitle=""
          text="Are you sure you want to delete this record?"
          showImage={false}
          cancelButtonText="No"
          confirmButtonText="Yes"
          spinConfirmButton={this.state.deletingUserCode}
          onConfirm={() => this.handleDeleteCompanyUserCode()}
          onHide={() => this.handleCloseDeleteConfirmation()} />
        <AppPageWrapper showNav>
          <Modal.Dialog size="lg">
            <Modal.Header>
              <Modal.Title className="text-uppercase">Company User Codes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Row className="form-group required">
                <Form.Label column sm={3} htmlFor="selectedCompany">
                  Company:
                  {(companyUserCodesLoading) && <Spinner animation="border" variant="secondary" />}
                </Form.Label>
                <Col sm={9}>
                  <CompanyInput id="selectedCompany" onChange={items => this.handleCompanyChange(items)} />
                </Col>
              </Form.Row>

              <Form.Row className="form-group required">
                <Form.Label column sm={3} htmlFor="implementationField">
                  User Code Type:
                  {(implementationFieldsLoading) && <Spinner animation="border" variant="secondary" />}
                </Form.Label>
                <Col sm={9}>
                  <Form.Control id="implementationField" as="select" onChange={this.handleImplementationFieldChange}>
                    {implementationFields && implementationFields.map((keyValue: KeyValue) => <option value={keyValue.Key} key={keyValue.Key}>{keyValue.Value}</option>)}
                  </Form.Control>
                </Col>
              </Form.Row>
              <Form.Row>
                <Table responsive bordered className="dark text-center">
                  <thead><tr><th className="w-50">Code&nbsp;
                    {(loading) && <Spinner animation="border" variant="secondary" />}

                  </th><th className="w-50">Name/Description</th><th>&nbsp;</th></tr></thead>
                  <tbody>{companyUserCodesLoading ? <tr><td colSpan={3}><Spinner animation="border" size="sm" /></td></tr> :
                    companyUserCodes.map((item, index) => this.DataRow(item, index))}</tbody>
                </Table>
              </Form.Row>
            </Modal.Body>
            <Modal.Footer>
              <ActionButton variant="primary" onClick={() => this.handleAdd()} disabled={loading} spin={loading} disableOnSpin>Add</ActionButton>
              <Button variant="secondary" className="mr-2" onClick={() => this.handleCancel()}>Cancel</Button>
            </Modal.Footer>
          </Modal.Dialog>
        </AppPageWrapper>
      </>
    )
  }
}
function assignedClinicToIdName(src: AssignedClinic) : IdName{
  const result : IdName = {
    ID: src.AccountID || 0,
    Name: src.Name || ""
  }
  return result
}
function assignedClinicsToIdNames(src: AssignedClinic[]) : IdName[]{
  const result : IdName[] = []
  for(let i = 0; i < src.length; i++)
  {
   const item = assignedClinicToIdName(src[i])
   result.push(item)
  }
  return result
}

function mapStateToProps(state: AppState): UserCodesModalAuthProps {

  let result: UserCodesModalAuthProps = {
    isPortalAdmin: isPortalAdmin(state),
    isCompanyAdmin: isCompanyAdmin(state),
    UserName: getUserNameForSelectedCompany(state),
    Company: GetSelectedAssignedClinic(state) || undefined,
    Portal: GetSelectedPortal(state)
  }
  return result

}
const ConnectedUserCodesModal = connect(mapStateToProps, null)(UserCodesModal)
export default ConnectedUserCodesModal